import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 客户门点信息
export function trucking(params) {
  return request({
    url: URL.seaExport.trucking,
    method: 'get',
    params
  })
}

// 派单(鸭嘴兽)
export function sendTruckOrder2Duck(data) {
  return request({
    url: URL.seaExport.sendTruckOrder2Duck,
    method: 'post',
    data
  })
}

// 派单
export function sendTruckOrder(data) {
  return request({
    url: URL.seaExport.sendTruckOrder,
    method: 'post',
    data
  })
}
// 改单
export function sendModifiedTruckOrder(data) {
  return request({
    url: URL.seaExport.sendModifiedTruckOrder,
    method: 'post',
    data
  })
}
// 撤单
export function revokeTruckOrder(data) {
  return request({
    url: URL.seaExport.revokeTruckOrder,
    method: 'post',
    data
  })
}
// 查询派车单
export function getTruckOrder(data) {
  return request({
    url: URL.seaExport.getTruckOrder,
    method: 'post',
    data
  })
}

// 派车单日志
export function queryTuckOrderLog(params) {
  return request({
    url: URL.seaExport.queryTuckOrderLog,
    method: 'get',
    params
  })
}

// 派车单日志
export function queryEventLogList(params) {
  return request({
    url: URL.seaExport.queryEventLogList,
    method: 'get',
    params
  })
}
// 陆运-列表查询
export function queryLandTransportation(data) {
  return request({
    url: URL.seaExport.queryLandTransportation,
    method: 'post',
    data
  })
}
// 陆运-列表查询
export function queryTruckingInfo(params) {
  return request({
    url: URL.seaExport.queryTruckingInfo,
    method: 'get',
    params
  })
}
// 陆运-编辑保存
export function saveTruckingInfo(data) {
  return request({
    url: URL.seaExport.saveTruckingInfo,
    method: 'post',
    data
  })
}

// 客户门点匹配运价 (海创定制)
export function matchingPriceFunc(data) {
  return request({
    url: URL.seaExport.matchingPriceUrl,
    method: 'post',
    data
  })
}
// 客户门点匹配运价 (海创定制)
export function matchingPricePageFunc(data) {
  return request({
    url: URL.seaExport.matchingPricePageUrl,
    method: 'post',
    data
  })
}

// 陆运（查询）
export function queryLandTranQuery(data) {
  return request({
    url: URL.seaExport.queryLandTranQuery,
    method: 'post',
    data
  })
}

// 同步客户门点信息到目的港派车
export function syncTruckingToDischargingTruckingInfo(data) {
  return request({
    url: URL.seaExport.syncTruckingToDischargingTruckingInfo,
    method: 'post',
    data
  })
}

// 导入excel
export function importTruckExcelData(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.integratedJob.importTruckExcelData,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}
